import { render, staticRenderFns } from "./NewFriend.vue?vue&type=template&id=7e0a2310&scoped=true"
import script from "./NewFriend.vue?vue&type=script&lang=js"
export * from "./NewFriend.vue?vue&type=script&lang=js"
import style0 from "./NewFriend.vue?vue&type=style&index=0&id=7e0a2310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0a2310",
  null
  
)

export default component.exports